/**
 * APP-AI-2: AI suggestions for the paste-to-assign drawer.
 *
 * The server redacts the paste before anything reaches a provider and returns
 * only suggestions it verified. Nothing here writes: an accepted suggestion
 * becomes an ordinary staged row, and bulk-assign re-validates everything.
 */
import { adminFetch } from '@/lib/adminApi';

export interface UnitSuggestion {
  suggestion_id: string;
  kind: 'unit';
  fragment_id: string;
  /** The redacted fragment the server sent; blanked words read as "·". */
  fragment_text: string;
  span: [number, number];
  evidence: string;
  unit_id: string;
  unit_code: string;
  confidence: number;
}

export interface DateRangeSuggestion {
  suggestion_id: string;
  kind: 'date_range';
  fragment_id: string;
  fragment_text: string;
  span: [number, number];
  evidence: string;
  start: string;
  end: string;
  confidence: number;
}

export type PasteSuggestion = UnitSuggestion | DateRangeSuggestion;

export interface PasteAssistResponse {
  available: boolean;
  reason?: string;
  skipped?: 'nothing_to_send';
  served_by?: 'anthropic' | 'openai' | null;
  failed_over?: boolean;
  model?: string;
  suggestions?: PasteSuggestion[];
  too_ambiguous?: string[];
  dropped_count?: number;
  assist_session_id?: string | null;
}

export function getPasteAssistStatus(): Promise<{ available: boolean }> {
  return adminFetch<{ available: boolean }>('/units/bulk-assign/assist/status');
}

export function requestPasteAssist(text: string, needDates: boolean): Promise<PasteAssistResponse> {
  return adminFetch<PasteAssistResponse>('/units/bulk-assign/assist', {
    method: 'POST',
    body: JSON.stringify({ text, need_dates: needDates }),
  });
}
